export default "__VITE_ASSET__qXO70IyW__"